
document.addEventListener('DOMContentLoaded', () => {
	const form = document.querySelector('#claim_form') as HTMLFormElement | null;
	if (!form) return; // Asegúrate de que el formulario existe

	// Variable para almacenar los datos de empresas
	let data: any[] = [];

	// Referencias a los selectores y los inputs ocultos
	const marcaSelect = document.querySelector('select[name="nombre_comercial"]') as HTMLSelectElement;
	const empresaSelect = document.querySelector('select[name="nombre_empresa"]') as HTMLSelectElement;
	const rucInput = document.querySelector('input[name="ruc"]') as HTMLInputElement;
	const empresaHiddenInput = document.querySelector('input[name="empresa"]') as HTMLInputElement;
	const entidadAfiliadaHiddenInput = document.querySelector('input[name="entidad_afiliada"]') as HTMLInputElement;

	// Cargar datos desde el JSON generado por WordPress
	async function loadEmpresasData() {
		try {
			// Intentar cargar desde diferentes ubicaciones de tema
			const possibleUrls = [
				'/wp-content/themes/dci/empresas.json',
				'/wp-content/themes/generatepress_child/empresas.json'
			];
			
			let data_loaded = false;
			
			for (const jsonUrl of possibleUrls) {
				try {
					const response = await fetch(jsonUrl);
					if (response.ok) {
						data = await response.json();
						console.log('JSON encontrado');
						data_loaded = true;
						break;
					}
				} catch (error) {
					// Continuar con la siguiente URL
				}
			}
			
			if (!data_loaded) {
				throw new Error('URL no encontrada');
			}
			
			// Inicializar los selectores después de cargar los datos
			initializeSelectors();
			
		} catch (error) {
			console.error('URL no encontrada');
			// Fallback: usar datos vacíos o mostrar mensaje de error
			data = [];
			showError('Error al cargar las empresas. Por favor, recarga la página.');
		}
	}

	// Mostrar mensaje de error
	function showError(message: string) {
		const errorDiv = document.createElement('div');
		errorDiv.className = 'error-message';
		errorDiv.style.cssText = 'background: #ffebee; color: #c62828; padding: 10px; margin: 10px 0; border-radius: 4px; border: 1px solid #ef5350;';
		errorDiv.textContent = message;
		
		if (marcaSelect && marcaSelect.parentNode) {
			marcaSelect.parentNode.insertBefore(errorDiv, marcaSelect);
		}
	}

	// Inicializar los selectores con los datos cargados
	function initializeSelectors() {
		if (!marcaSelect || !empresaSelect || !rucInput) {
			console.error('No se encontraron los elementos del formulario');
			return;
		}

		// Poblar el primer selector (nombre_comercial) con las marcas
		data.forEach((item) => {
			const option = document.createElement("option");
			option.value = item.marca.value; // RUC como valor
			option.textContent = item.marca.label; // Nombre visible
			marcaSelect.appendChild(option);
		});

		// Evento para actualizar el segundo selector (nombre_empresa) y el input RUC basado en la marca seleccionada
		marcaSelect.addEventListener("change", (event) => {
			const selectedMarca = (event.target as HTMLSelectElement).value;

			// Limpiar el segundo selector
			empresaSelect.innerHTML = '<option value="" disabled selected>Empresa o razón social *</option>';
			rucInput.value = ""; // Limpiar el input RUC

			// Actualizar el input oculto "empresa" con el nombre de la opción seleccionada
			if (empresaHiddenInput) {
				const selectedOption = marcaSelect.selectedOptions[0]; // Opción seleccionada
				empresaHiddenInput.value = selectedOption ? selectedOption.textContent || '' : '';
			}

			// Encontrar las empresas relacionadas con la marca seleccionada
			const relatedData = data.find((item) => item.marca.value === selectedMarca);
			if (relatedData) {
				relatedData.empresas.forEach((empresa: any) => {
					const option = document.createElement("option");
					option.value = empresa.value; // RUC como valor
					option.textContent = empresa.label; // Nombre visible
					empresaSelect.appendChild(option);
				});

				// Actualizar el input RUC con el valor de la marca seleccionada
				rucInput.value = relatedData.marca.value;
			}
		});

		// Evento para actualizar el input RUC y el input oculto "entidad_afiliada" basado en la empresa seleccionada
		empresaSelect.addEventListener("change", (event) => {
			const selectedEmpresa = (event.target as HTMLSelectElement).value;

			// Actualizar el input RUC con el valor de la empresa seleccionada
			rucInput.value = selectedEmpresa;

			// Actualizar el input oculto "entidad_afiliada" con el nombre de la opción seleccionada
			if (entidadAfiliadaHiddenInput) {
				const selectedOption = empresaSelect.selectedOptions[0]; // Opción seleccionada
				entidadAfiliadaHiddenInput.value = selectedOption ? selectedOption.textContent || '' : '';
			}
		});

		// Evento para comparar el RUC ingresado con el array de datos
		rucInput.addEventListener("input", (event) => {
			const enteredRuc = (event.target as HTMLInputElement).value;

			// Limpiar los selectores
			marcaSelect.value = "";
			empresaSelect.innerHTML = '<option value="" disabled selected>Empresa o razón social *</option>';

			// Buscar coincidencias en el array de datos
			const matchedData = data.find(
				(item) =>
					item.marca.value === enteredRuc ||
					item.empresas.some((empresa: any) => empresa.value === enteredRuc)
			);

			if (matchedData) {
				// Actualizar el selector de marcas
				marcaSelect.value = matchedData.marca.value;

				// Actualizar el selector de empresas
				matchedData.empresas.forEach((empresa: any) => {
					const option = document.createElement("option");
					option.value = empresa.value; // RUC como valor
					option.textContent = empresa.label; // Nombre visible
					empresaSelect.appendChild(option);
				});

				// Seleccionar automáticamente la empresa si coincide con el RUC ingresado
				const matchedEmpresa = matchedData.empresas.find((empresa: any) => empresa.value === enteredRuc);
				if (matchedEmpresa) {
					empresaSelect.value = matchedEmpresa.value;

					// Actualizar los inputs ocultos con los nombres de las opciones seleccionadas
					if (empresaHiddenInput) {
						empresaHiddenInput.value = matchedData.marca.label; // Nombre de la marca
					}
					if (entidadAfiliadaHiddenInput) {
						entidadAfiliadaHiddenInput.value = matchedEmpresa.label; // Nombre de la empresa
					}
				}
			}
		});

		console.log('Selectores inicializados correctamente');
	}

	// Iniciar la carga de datos
	loadEmpresasData();
});